/**
 * A module representing user answers.
 * @module feedback
 * @exports Feedback
 * @see Feedback
 * @requires module:training
 * @requires module:user-answers
 * @example
 * var Feedback = require('feedback');
 */
define('feedback',['training', 'user-answers'], function(Training, UserAnswers) {
    'use strict';

    var feedback,
        training,
        userAnswers;

    function getFeedback(ID, prop, feedbacks) {
        var res = '';

        feedbacks = feedbacks || [];

        if (!ID || !prop) {
            return res;
        }

        feedbacks.forEach(function(feedback) {
            if (ID === feedback[prop]) {
                res = feedback.text || '';
            }
        });

        return res;
    }

    /**
     * @constructor
     * @alias Feedbacks
     * @param {Object} options
     */
    function Feedback() {
        // options = options || {};
    }

    /**
     * Checks if entity contains any feedback text
     * @param {Object} entity - Entity
     * @returns {Boolean}
     */
    Feedback.prototype.contains = function(entity) {
        return (entity && Array.isArray(entity.feedbacks) && entity.feedbacks.filter(function(o) { return o.text }).length) ? true : false;
    }

    /**
     * Returns Feedback content by entity ID and user answer
     * @param {String} ID - Entity ID
     * @returns {String}
     */
    Feedback.prototype.getContent = function(ID) {
        var res = '',
            entity = training.getContent(ID);

        if (!entity) {
            return res;
        }

        switch(entity.typeID) {
        case 13:
            switch(entity.displayMode) {
            case 3:
                var feedbackID = (userAnswers.isTaskCorrect(ID)) ? entity.correctFeedbackID : entity.incorrectFeedbackID;

                res = getFeedback(feedbackID, 'id', entity.feedbacks);

                break;
            default:
                var answersID = userAnswers.getTaskAnswersID(ID),
                    answerID = (Array.isArray(answersID) && answersID.length) ? answersID[0] : '';

                res = (answerID) ? getFeedback(answerID, 'answerId', entity.feedbacks) : '';
            }
            break;
        default:
            res = getFeedback(ID, 'taskId', entity.feedbacks);
        }

        return res;
    };

    return function(options) {

        if (!feedback) {
            training = new Training();
            userAnswers = new UserAnswers();
            feedback = new Feedback(options);
        }

        return feedback;
    };
});

